import { render } from "./Card3.vue?vue&type=template&id=3cf87ff9"
import script from "./Card3.vue?vue&type=script&lang=ts"
export * from "./Card3.vue?vue&type=script&lang=ts"
script.render = render

export default script